import { EducationRecord } from 'types/commons';

import { FALLBACK_VALUE } from 'constants/uiSettings';

import { useTranslation } from 'react-i18next';
import styles from '../Education.module.scss';

interface EducationItemProps {
  record: EducationRecord;
}

const EducationItem = ({ record }: EducationItemProps) => {
  const { t } = useTranslation()
  return (
    <div className={styles.educationWrapper}>
      <div>
        <div className={styles.value}>
          {record.institution || FALLBACK_VALUE}
        </div>
        <div className={styles.label}>{t('education.institution')}</div>
      </div>

      <div className={styles.multipleDataWrapper}>
        <div className={styles.data}>
          <div className={styles.value}>{record.degree || FALLBACK_VALUE}</div>
          <div className={styles.label}>{t('education.degree')}</div>
        </div>
        <div className={styles.data}>
          <div className={styles.value}>
            {record.fieldOfStudy || FALLBACK_VALUE}
          </div>
          <div className={styles.label}>{t('education.field')}</div>
        </div>
      </div>

      <div className={styles.multipleDataWrapper}>
        <div className={styles.data}>
          <div className={styles.value}>
            {record.startDate || FALLBACK_VALUE}
          </div>
          <div className={styles.label}>{t('education.start')}</div>
        </div>
        <div className={styles.data}>
          <div className={styles.value}>{record.endDate || FALLBACK_VALUE}</div>
          <div className={styles.label}>{t('education.end')}</div>
        </div>
      </div>
    </div>
  );
};

export default EducationItem;
